'use strict';

var Backbone = require('backbone');
var mediator = require('../../../js/mediator');
var config = require('../../../js/config');
var VideoDeskBlock = require('./videoDeskBlock');
var agentStateTemplateFactory = require('./agentStateTemplateFactory');

class AgentListView extends Backbone.View {

  /**
   * @param {object} options
   * @param {boolean} options.shouldShowContactUs
   */
  initialize(options) {
    this.options = options;
    this.increment = this.$el.data('amount') || 20;
    this.pagesVisible = 1;
    this.itemViews = {};
    this.render();
    mediator.on(config.events.videoDesk.showMoreAgents, this.showMore, this);
    this.listenTo(this.collection, 'sort', this.render);
  }

  /**
   * Maintain a cache of all views based on a particular model
   * so that we don't keep recreating them
   *
   * @param agentModel
   * @returns {*}
   */
  getAgentViewByModel(agentModel, ensureView = true) {
    if (!agentModel.id) return;
    let itemView = this.itemViews[agentModel.id];
    if (!itemView && ensureView) {
      itemView = this.itemViews[agentModel.id] = new VideoDeskBlock({
        element: 'div',
        className: 'MyProjects-item--offGrid MyProjects-item--offGrid--PersonSquare',
        model: agentModel,
        template: agentStateTemplateFactory.getTemplateByState('video'),
        templateName: 'video',
        shouldShowContactUs: this.options.shouldShowContactUs,
        globalSettings: this.options.globalSettings,
        isList: true
      });
    }
    return itemView;
  }

  checkShowMoreVisibility() {
    let maxItems = this.increment * this.pagesVisible;
    if (this.collection.models.length <= maxItems) {
      mediator.trigger('agentlist:hideshowmore');
    }
  }

  /**
   * Places the agentView into the parent element at
   * a specified index. If the index is higher than the number
   * of elements it will go at the end
   *
   * @param agentView
   * @param i
   */
  sortAgentViewIntoIndex(agentView, i) {
    // could just quickly use prepend
    if (i === 0) {
      this.$el.prepend(agentView.el);
    } else {
      // see if there is already
      // a child at the index
      let childAtIndex = this.$el
        .children().eq(i);
      if (childAtIndex.length) {
        if (childAtIndex[0] !== agentView.el) {
          childAtIndex.before(agentView.el);
        }
      } else {
        this.$el.append(agentView.el);
      }
    }
  }

  /**
   * Retrieve a view for each agent model visible based on
   * paging, sort it then render it
   */
  render() {
    this.collection
      .each((model, i) => {
        let isCurrentlyVisible = i < this.increment * this.pagesVisible;
        let agentView = this.getAgentViewByModel(model, isCurrentlyVisible);
        if (agentView) {
          if (isCurrentlyVisible) {
            this.sortAgentViewIntoIndex(agentView, i);
          } else {
            agentView.$el.detach();
          }
          agentView.render();
        }
      });
    this.checkShowMoreVisibility();
  }

  showMore() {
    let maxItems = this.increment * this.pagesVisible;
    if (this.collection.models.length > maxItems) {
      this.pagesVisible += 1;
    }
    this.render();
    this.checkShowMoreVisibility();
  }

}

module.exports = AgentListView;



// WEBPACK FOOTER //
// ./assets/components/VideoDesk/views/agentListView.js